import { MultiSelect } from '@library/components/selects/multiSelect/MultiSelect';
import type { SelectOptions } from '@library/types/utils';

export interface GameModesSelectProps {
  gameModeOptions: SelectOptions;
  gameModeValues: Array<string>;
  height: string;
  iconOnly?: boolean;
  onChange: (gameModes: SelectOptions) => void;
  savingDisabled?: boolean;
  transparentBackground?: boolean;
}

export const GameModesSelect = ({
  height,
  iconOnly = false,
  gameModeOptions,
  gameModeValues,
  onChange,
  savingDisabled = false,
  transparentBackground = false
}: GameModesSelectProps) => {
  return (
    <MultiSelect
      allOption
      customHeight={height}
      disabled={false}
      iconOnly={iconOnly}
      onChange={onChange}
      options={gameModeOptions}
      portal
      savingDisabled={savingDisabled}
      size="extrasmall"
      testId="roles"
      transparentBackground={transparentBackground}
      values={gameModeValues}
    />
  );
};
